import React from 'react';

import { getTranslation, keys } from '../../../Resources/Translations';
import { CheapestForFreeDiscountViewModel } from '../../Blocks/CheapestForFreeDiscount/CheapestForFreeDiscountViewModel.csharp';
import { DiscountType } from '../../Blocks/DiscountType.csharp';
import { DiscountVariant } from '../../Blocks/DiscountVariant.csharp';
import { CircleInfoLabel, StarInfoLabelColor } from './CircleInfoLabel';
import { ProductTopLabelProps } from './ProductTopLabelProps.csharp';

export const ProductTopLabel: React.FunctionComponent<ProductTopLabelProps> = (props) => {
    if (!props.showPromoStar) return null;

    if (
        !props.showOnlyFreeItemBadge &&
        !props.badgeSettings.hidePercentagePromotionBadge &&
        props.promotions &&
        props.promotions.length > 0 &&
        props.promotions[0].promotionInfo.type == DiscountType.Product
    ) {
        return <CircleInfoLabel color={StarInfoLabelColor.Red} variant={props.variant} value={props.promotions[0].shortInfo} />;
    }
    if (
        !props.badgeSettings.hideFreeItemPromotionBadge &&
        props.promotions &&
        props.promotions.length > 0 &&
        props.promotions[0].promotionInfo.type == DiscountType.CheapestForFree
    ) {
        const cheapestDiscount = props.promotions[0].promotionInfo as CheapestForFreeDiscountViewModel;
        const variant = props.showOnlyFreeItemBadge ? DiscountVariant.Mini : props.variant;
        return (
            <CircleInfoLabel
                color={StarInfoLabelColor.Red}
                variant={variant}
                value={props.promotions[0].shortInfo}
                requiredQuantity={cheapestDiscount.requiredQuantity}
                paidQuantity={cheapestDiscount.paidQuantity}
            />
        );
    }
    if (!props.showOnlyFreeItemBadge && !props.badgeSettings.hideFixedLowPriceBadge && props.showFixedLowPriceBadge) {
        return (
            <CircleInfoLabel
                color={StarInfoLabelColor.Pink}
                variant={props.variant}
                value={getTranslation(keys['enum.infoBanner.lowPrice2'])}
                additionalInfo={getTranslation(keys['enum.infoBanner.lowPrice1'])}
            />
        );
    }
    if (!props.showOnlyFreeItemBadge && !props.badgeSettings.hideGoodPurchaseBadge && props.showGoodPurchaseBadge) {
        return (
            <CircleInfoLabel
                color={StarInfoLabelColor.DarkRed}
                variant={props.variant}
                value={getTranslation(keys['enum.infoBanner.goodPurchase2'])}
                additionalInfo={getTranslation(keys['enum.infoBanner.goodPurchase1'])}
            />
        );
    }
    return null;
};
